export const MOBILE_ENVS = ['production', 'preprod', 'testing'];

export const MOBILE_SECTIONS = [
    'navigation',
    'screens',
    'features',
    'theme',
    'config',
];

export const MOBILE_SCREENS = [
    'home',
    'program',
    'news',
    'tickets',
    'shop',
    'cart',
    'favorites',
    'ratings',
];

const DEFAULT_ENV = 'production';
const DEFAULT_SECTION = 'navigation';
const DEFAULT_SCREEN = 'home';

/**
 * Parse the settings field splat for mobile nested routes.
 *
 * Supported shapes:
 * - mobile
 * - mobile/:env
 * - mobile/:env/:section
 * - mobile/:env/screens/:screenId
 *
 * @param {string|null|undefined} field_raw
 * @returns {{
 *   base_field: string|null,
 *   env: string,
 *   section: string,
 *   screen_id: string|null,
 * }}
 */
export function parse_mobile_settings_route(field_raw) {
    const trimmed = field_raw != null ? String(field_raw).replace(/\/+$/, '') : '';
    if (trimmed === '') {
        return {
            base_field: null,
            env: DEFAULT_ENV,
            section: DEFAULT_SECTION,
            screen_id: null,
        };
    }

    let decoded = trimmed;
    try {
        decoded = decodeURIComponent(trimmed);
    } catch (_e) {
        decoded = trimmed;
    }

    const segments = decoded.split('/').filter(Boolean);
    const base_field = segments[0] || null;
    if (base_field !== 'mobile') {
        return {
            base_field,
            env: DEFAULT_ENV,
            section: DEFAULT_SECTION,
            screen_id: null,
        };
    }

    const env = MOBILE_ENVS.includes(segments[1]) ? segments[1] : DEFAULT_ENV;
    const section = MOBILE_SECTIONS.includes(segments[2])
        ? segments[2]
        : DEFAULT_SECTION;
    const screen_id = section === 'screens' && MOBILE_SCREENS.includes(segments[3])
        ? segments[3]
        : null;

    return { base_field, env, section, screen_id };
}

/**
 * @param {string} setting_id
 * @param {string} [env]
 * @param {string} [section]
 * @param {string|null} [screen_id]
 * @returns {string}
 */
export function mobile_settings_path(
    setting_id,
    env = DEFAULT_ENV,
    section = DEFAULT_SECTION,
    screen_id = null
) {
    const safe_env = MOBILE_ENVS.includes(env) ? env : DEFAULT_ENV;
    const safe_section = MOBILE_SECTIONS.includes(section)
        ? section
        : DEFAULT_SECTION;
    const parts = [
        'settings',
        'edit',
        setting_id,
        'mobile',
        safe_env,
        safe_section,
    ];

    if (
        safe_section === 'screens'
        && screen_id
        && MOBILE_SCREENS.includes(screen_id)
    ) {
        parts.push(screen_id);
    } else if (safe_section === 'screens') {
        parts.push(DEFAULT_SCREEN);
    }

    return `/${parts.map((p) => encodeURIComponent(String(p))).join('/')}`;
}
